import styled from "styled-components";
import colors from "css/colors";
import { Space } from "antd";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 1200px) {
    margin: -25px 0 0;
  }
  @media screen and (min-width: 1439) {
    margin: -25px;
  }

  input,
  textarea {
    font-size: 16px !important;
    color: ${colors.CHARCOAL} !important;
  }

  .ant-input-disabled,
  .ant-input-number-disabled {
    background: ${colors.GREY_BACKGROUND};
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 32px 32px 80px 32px;
`;

export const Container = styled(Space)`
  width: 100%;
  margin: 2em 0;
`;

export const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h4.ant-typography {
    margin-bottom: 0;
  }
`;
